export { default as SearchAiSolidIcon } from './SearchAiSolidIcon';
